/* eslint-disable jsx-a11y/media-has-caption */
import { WagtailVideo } from '@/types';

interface Props {
  video: WagtailVideo;
}

function Video(props: Props) {
  const { video } = props;

  return (
    <div className='streamfield video'>
      <video preload='none' width='100%' controls poster={video.thumbnail ?? ''}>
        <source src={video.file} />
        {video.transcodes.map(transcode =>
          !transcode.processing ? (
            <source
              key={transcode.id}
              src={transcode.file}
              type={`video/${transcode.media_format}`}
            />
          ) : null,
        )}
      </video>
    </div>
  );
}

export default Video;
